export enum QuestsType {
  ACTIVE,
  COMINGSOON,
  ENDED,
}